import { Component } from '@angular/core';

import { AuthenticationService } from 'app/core/authentication';
@Component({
    selector: 'kh-forbidden',
    templateUrl: './forbidden.component.html',
    styleUrls: ['./forbidden.component.less'],
    standalone: false
})
export class ForbiddenComponent {

  public constructor(private readonly authenticationService: AuthenticationService) { }

  public logOut(): void {
    this.authenticationService.logOut();
  }

}
